module.exports = __webpack_public_path__ + "img/arrowlink.63b2fbe0.svg";